export default __webpack_public_path__ + "static/media/dash_logo.64958474.png";